import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, useHistory } from 'react-router-dom';
import Skeleton from '../common/skeleton';
import Api from '../../common/api';
import { refreshToken, requestCurrentUserIRS } from '@/store/actions/authenticate';
import { verifyToken } from '@/utils/authenticate';
import { getXBusinessGuid } from '@/utils/business';
import { ROUTE_BEFORE_LOGIN } from '@/common/constant';

const PrivateRoute = ({ children, ...rest }) => {
  const { path } = rest;
  const history = useHistory();
  const authenticate = useSelector((state) => state.authenticate);
  const dispatch = useDispatch();
  const api = Api.getApi();
  const irsApi = Api.getApiIRS();

  const [isLoad, setLoad] = useState(true);
  // checking authenticate
  const { token, isExpired } = verifyToken();
  if (!token) {
    sessionStorage.setItem(ROUTE_BEFORE_LOGIN, rest?.location?.pathname);
    history.push('/login');
    return null;
  }
  useEffect(() => {
    if (token.access_token) {
      api.setToken(token.access_token);
      irsApi.setToken(token.access_token);
    }
  }, [token.access_token]);

  const getUser = () => {
    if (!authenticate.user) {
      dispatch(requestCurrentUserIRS());
    }
  };

  /**
   * Handle refresh token
   */
  const requestRefreshToken = () => {
    dispatch(
      refreshToken({}, (isSuccess) => {
        if (!isSuccess) {
          return history.push('/login');
        }
        getUser();
        return setLoad(false);
      }),
    );
  };

  useEffect(() => {
    requestRefreshToken();
    getXBusinessGuid();
  }, []);

  useEffect(() => {
    // refresh token when change url and token is expired
    if (isExpired) {
      setLoad(true);
      requestRefreshToken();
    }
  }, [path]);

  return isLoad || !authenticate.user ? <Skeleton loading /> : <Route {...rest} />;
};

export default PrivateRoute;
